import { registerComponent } from './helpers';
import ColumnsSidebar from './components/columns-sidebar';

export default class ResearchFlow {
	constructor(root) {
		this.url = new URL(window.location.href);
		this.typeSelect = document.querySelector('.js-research-flow-type-select');
		this.nextBtn = document.querySelector('.js-research-flow-next');
		this.prevBtn = document.querySelector('.js-research-flow-prev');
		this.countryPicker = document.querySelector('.accordion[data-name="country-picker"]');
		this.themePicker = document.querySelector('.themes-grid');
		this.timePeriodPicker = document.querySelector('.accordion[data-name="research-time-periods"]');
		this.contextPicker = document.querySelector('.accordion[data-name="contexts"]');
		this.subThemePicker = document.querySelector('.accordion[data-name="sub-themes"]');

		const queryParams = new URLSearchParams(window.location);
		this.step = queryParams.get('step');

		registerComponent('.columns-sidebar', ColumnsSidebar);

		// Indicates we are on the type select page
		if (this.typeSelect) {
			const types = this.typeSelect.querySelectorAll('input[name="type"]');

			types.forEach((type) => {
				type.addEventListener('click', (e) => {
					if (this.nextBtn) {
						const params = new URLSearchParams(this.nextBtn.getAttribute('href'));
						params.set('type', e.target.value);
						params.set('step', 1);
						this.nextBtn.classList.remove('disabled');
						this.nextBtn.setAttribute('href', '?' + params.toString());
					}
				});
			});
		}

		// Indicates we are dealing with the country picker
		if (this.countryPicker) {
			const items = this.countryPicker?.querySelectorAll('.accordion-item');

			this.nextBtn.addEventListener('click', (e) => {
				if (
					!this.countryPicker.querySelector(
						'.accordion-item:has(>button[aria-expanded="true"]) button[role="tab"][aria-selected="true"]'
					)
				) {
					e.preventDefault();
					document
						.querySelectorAll('.accordion-item:has(>button[aria-expanded="true"]) .error')
						.forEach((error) => {
							console.log(error);
							error.classList.remove('hidden');
						});
				}
			});

			items.forEach((item) => {
				const tabs = item.querySelectorAll('button[role="tab"][aria-controls]');
				tabs.forEach((tab) => {
					tab.addEventListener('click', () => {
						const slug = tab.getAttribute('data-slug');
						this.setCountry(slug);
						tabs.forEach((_tab) => {
							const id = _tab.getAttribute('aria-controls');
							const tabContent = item.querySelector('#' + id);
							const image = item.querySelector('#image-' + id);
							_tab.setAttribute('aria-selected', 'false');
							tabContent?.classList.add('hidden');
							image?.classList.add('hidden');

							if (_tab.isSameNode(tab)) {
								_tab.setAttribute('aria-selected', 'true');
								tabContent?.classList.remove('hidden');
								image?.classList.remove('hidden');
							}
						});
					});
				});
			});
		}

		// Indicates we are dealing with the theme picker
		if (this.themePicker) {
			const items = this.themePicker.querySelectorAll('[role="button"][data-slug]');

			this.nextBtn.addEventListener('click', (e) => {
				if (!this.themePicker.querySelector('[role="button"][data-slug][aria-selected="true"]')) {
					e.preventDefault();
				}
			});

			items.forEach((item) => {
				const slug = item.getAttribute('data-slug');

				item.addEventListener('click', () => {
					items.forEach((item) => {
						item.setAttribute('aria-selected', 'false');
					});

					item.setAttribute('aria-selected', 'true');
					this.setTheme(slug);
				});
			});
		}

		// Indicates we are dealing with the time period picker
		if (this.timePeriodPicker) {
			this.nextBtn.classList.add('disabled');

			this.nextBtn.addEventListener('click', (e) => {
				const terms = this.timePeriodPicker.getAttribute('data-value');
				if (!terms) {
					e.preventDefault();
				}
			});

			const observer = new MutationObserver((mutations) => {
				mutations.forEach((m) => {
					if (m.type === 'attributes' && m.attributeName === 'data-value') {
						const terms = this.timePeriodPicker.getAttribute('data-value');
						if (terms) {
							const url = new URL(strl_vars.source_locations_overview);
							url.search = terms;
							this.nextBtn.href = url.toString();
							this.nextBtn.classList.remove('disabled');
						} else {
							this.nextBtn.classList.add('disabled');
							this.nextBtn.href = '';
						}
					}
				});
			});

			observer.observe(this.timePeriodPicker, { attributes: true });
		}

		// Indicates we are dealing with the context picker
		if (this.contextPicker) {
			this.nextBtn.classList.add('disabled');

			this.nextBtn.addEventListener('click', (e) => {
				const terms = this.contextPicker.getAttribute('data-value');
				if (!terms) {
					e.preventDefault();
				}
			});

			const observer = new MutationObserver((mutations) => {
				mutations.forEach((m) => {
					if (m.type === 'attributes' && m.attributeName === 'data-value') {
						const terms = this.contextPicker.getAttribute('data-value');
						if (terms) {
							const url = new URL(strl_vars.source_locations_overview);
							url.search = terms;
							this.nextBtn.href = url.toString();
							this.nextBtn.classList.remove('disabled');
						} else {
							this.nextBtn.classList.add('disabled');
							this.nextBtn.href = '';
						}
					}
				});
			});

			observer.observe(this.contextPicker, { attributes: true });
		}

		// Indicates we are dealing with the sub theme picker
		if (this.subThemePicker) {
			this.nextBtn.classList.add('disabled');

			this.nextBtn.addEventListener('click', (e) => {
				const terms = this.subThemePicker.getAttribute('data-value');
				if (!terms) {
					e.preventDefault();
				}
			});

			const observer = new MutationObserver((mutations) => {
				mutations.forEach((m) => {
					if (m.type === 'attributes' && m.attributeName === 'data-value') {
						const terms = this.subThemePicker.getAttribute('data-value');
						if (terms) {
							const url = new URL(strl_vars.source_locations_overview);
							url.search = terms;
							this.nextBtn.href = url.toString();
							this.nextBtn.classList.remove('disabled');
						} else {
							this.nextBtn.classList.add('disabled');
							this.nextBtn.href = '';
						}
					}
				});
			});

			observer.observe(this.subThemePicker, { attributes: true });
		}
	}

	setCountry(country) {
		const queryParams = new URLSearchParams(this.nextBtn.getAttribute('href'));
		queryParams.set('country', country);
		this.nextBtn.setAttribute('href', '?' + queryParams.toString());
	}

	setTheme(theme) {
		const queryParams = new URLSearchParams(this.nextBtn.getAttribute('href'));
		queryParams.set('theme', theme);
		this.nextBtn.setAttribute('href', '?' + queryParams.toString());
	}
}

const researchFlow = new ResearchFlow(document.querySelector('body.page-template-page-research-flow'));
